// extracted by css-extract-rspack-plugin
export default {"container":"QuestionBody-module__container___pMM2U","readOnly":"QuestionBody-module__readOnly___C_M6L","collapsed":"QuestionBody-module__collapsed___jcPXA"};